import { render, staticRenderFns } from "./AdTable.vue?vue&type=template&id=47de2b4d&scoped=true&"
import script from "./AdTable.vue?vue&type=script&lang=js&"
export * from "./AdTable.vue?vue&type=script&lang=js&"
import style0 from "./AdTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdTable.vue?vue&type=style&index=1&id=47de2b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de2b4d",
  null
  
)

export default component.exports